import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";

var Nodes = /*#__PURE__*/function () {
  function Nodes(node_id) {
    _classCallCheck(this, Nodes);

    this.node_id = node_id;
    this.nodes = [];
    this.nodeCallbacks = [];
    this.elementListeners = new Map();
  }

  _createClass(Nodes, [{
    key: "attachNodeCallback",
    value: function attachNodeCallback(nodeCallback) {
      this.nodeCallbacks.push(nodeCallback);
    }
  }, {
    key: "attachElementListener",
    value: function attachElementListener(type, node, elementListener) {
      var id = this.getID(node);

      if (id === undefined) {
        return;
      }

      node.addEventListener(type, elementListener);
      var listeners = this.elementListeners.get(id);

      if (listeners === undefined) {
        listeners = [];
        this.elementListeners.set(id, listeners);
        return;
      }

      listeners.push([type, elementListener]);
    }
  }, {
    key: "registerNode",
    value: function registerNode(node) {
      var id = node[this.node_id];
      var isNew = id === undefined;

      if (isNew) {
        id = this.nodes.length;
        this.nodes[id] = node;
        node[this.node_id] = id;
      }

      return [id, isNew];
    }
  }, {
    key: "unregisterNode",
    value: function unregisterNode(node) {
      var id = node[this.node_id];

      if (id !== undefined) {
        delete node[this.node_id];
        delete this.nodes[id];
        var listeners = this.elementListeners.get(id);

        if (listeners !== undefined) {
          this.elementListeners.delete(id);
          listeners.forEach(function (listener) {
            return node.removeEventListener(listener[0], listener[1]);
          });
        }
      }

      return id;
    }
  }, {
    key: "cleanTree",
    value: function cleanTree() {
      // sadly we keep empty items in array here resulting in some memory still being used
      // but its still better than keeping dead nodes or undef elements
      // plus we keep our index positions for new/alive nodes
      // performance test: 3ms for 30k nodes with 17k dead ones
      for (var i = 0; i < this.nodes.length; i++) {
        var node = this.nodes[i];

        if (node && !document.contains(node)) {
          this.unregisterNode(node);
        }
      }
    }
  }, {
    key: "callNodeCallbacks",
    value: function callNodeCallbacks(node, isStart) {
      this.nodeCallbacks.forEach(function (cb) {
        return cb(node, isStart);
      });
    }
  }, {
    key: "getID",
    value: function getID(node) {
      return node[this.node_id];
    }
  }, {
    key: "getNode",
    value: function getNode(id) {
      return this.nodes[id];
    }
  }, {
    key: "clear",
    value: function clear() {
      for (var id = 0; id < this.nodes.length; id++) {
        var node = this.nodes[id];

        if (node === undefined) {
          continue;
        }

        this.unregisterNode(node);
      }

      this.nodes.length = 0;
    }
  }]);

  return Nodes;
}();

export { Nodes as default };